import { createTheme } from '@mui/material/styles';

// Light minimal theme (the Dice family on alkanes.app): white surfaces, ink text, one red accent.
// File name kept so imports stay put.
const casinoTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#ff3e00', contrastText: '#ffffff' },
    secondary: { main: '#6b6a68', contrastText: '#ffffff' },
    background: { default: 'transparent', paper: '#ffffff' },
    text: { primary: '#343433', secondary: '#6b6a68' },
    divider: '#ece7df',
  },
  typography: {
    fontFamily: 'Inter, -apple-system, "Segoe UI", Roboto, sans-serif',
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: { background: '#ffffff', border: '1px solid #ece7df', borderRadius: 20, color: '#343433' },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { background: '#ffffff', border: '1px solid #ece7df', color: '#343433', borderRadius: 14 },
      },
    },
    MuiCircularProgress: {
      styleOverrides: { root: { color: '#6b6a68' } },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: '#343433',
          background: '#f6f3ee',
          borderRadius: 12,
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#ece7df' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#a9a49b' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#343433' },
        },
        input: { color: '#343433' },
      },
    },
    MuiSvgIcon: {
      styleOverrides: { root: { color: '#6b6a68', filter: 'none' } },
    },
  },
});

export default casinoTheme;
